import { format } from "date-fns";
import * as React from "react";

import { DateFormat } from "constants/date";
import { heatmapCommonOptions } from "constants/heatmap-common-options";
import { trackHoveredHeatmap } from "helpers/analytics-reports";
import { IHeatmapOptions } from "store/views/reports";

import { wrapperStyles } from "../styled/heatmap";
import "../styled/heatmap.css";

import { ChartPanel } from "./ChartPanel";

interface IHeatmapTooltip {
  heatmapTooltipName: string;
}

interface IProps {
  title: string;
  heatmapTooltipName: string;
  loading: boolean;
  options: IHeatmapOptions;
  exportFileName?: string;
}

const HeatmapTooltip: React.FC<IHeatmapTooltip> = ({ heatmapTooltipName }) => (
  <>
    <p>
      Check the time of day you got the most {heatmapTooltipName} last week. Use this data to prepare your team for
      traffic peaks.
    </p>
  </>
);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const prepareSeries = (series: any) => ({
  ...heatmapCommonOptions.series[0],
  data: series.data,
  name: series.name,
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const prepareLegend = (legend: any) => ({
  ...heatmapCommonOptions.legend,
  title: { text: legend.title },
  symbolWidth: legend.symbolWidth || heatmapCommonOptions.legend.symbolWidth,
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const prepareChart = (chart: any) => ({
  ...heatmapCommonOptions.chart,
  height: (chart && chart.height) || heatmapCommonOptions.chart.height,
  marginTop: (chart && chart.marginTop) || heatmapCommonOptions.chart.marginTop,
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const prepareColor = (color: any) => ({
  ...heatmapCommonOptions.colorAxis,
  minColor: (color && color.minColor) || heatmapCommonOptions.colorAxis.minColor,
  maxColor: (color && color.maxColor) || heatmapCommonOptions.colorAxis.maxColor,
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
const prepareOptions = (options: any) => {
  const { series, chart, legend, color, categories } = options;
  const heatmapSeries = prepareSeries(series);
  const heatmapLegend = prepareLegend(legend);
  const heatmapChart = prepareChart(chart);
  const heatmapColor = prepareColor(color);

  return {
    ...heatmapCommonOptions,
    chart: heatmapChart,
    legend: heatmapLegend,
    colorAxis: heatmapColor,
    xAxis: {
      ...heatmapCommonOptions.xAxis,
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      categories: categories.map((category: any) => ({
        value: category,
        label: format(category, DateFormat.DateWithoutYear),
      })),
      labels: {
        format: "{value.label}",
      },
    },
    series: [heatmapSeries],
    tooltip: {
      formatter(): string {
        // FIXME: Fix this the next time the file is edited.
        // @ts-expect-error TS(2339)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const point = this.point as any;
        return `
          <span class='heatmapts-tooltip-wrapper'>
            <span class='heatmapts-tooltip-header'>
              ${point.series.xAxis.categories[point.options.x].label}
              ${point.series.yAxis.categories[point.options.y]}
            </span>
            <span class='heatmapts-tooltip-body'>
              <span class='heatmapts-color-circle' style="background-color: ${point.color}"></span>
                ${series.name}: ${point.options.value}
            </span>
          </span>
        `;
      },
    },
  };
};

export class Heatmap extends React.Component<IProps> {
  state = {
    hoveredHeatmap: false,
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  trackHeatmapEvent = () => {
    if (!this.state.hoveredHeatmap) {
      this.setState({ hoveredHeatmap: true });
      const heatmapName = this.props.heatmapTooltipName;
      trackHoveredHeatmap(heatmapName);
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { title, heatmapTooltipName, options, loading, exportFileName } = this.props;
    const heatmapOptions = options && prepareOptions(options);

    return (
      <div css={wrapperStyles} onMouseEnter={this.trackHeatmapEvent}>
        <ChartPanel
          title={title}
          loading={loading}
          // @ts-expect-error TS(2769)
          options={heatmapOptions}
          tooltip={<HeatmapTooltip heatmapTooltipName={heatmapTooltipName} />}
          exportFileName={exportFileName}
          disableBreakdown
        />
      </div>
    );
  }
}
